import React, { useState } from "react";
import "../styles/ApplyOnline.css";

export default function ApplyOnline() {
  const [formData, setFormData] = useState({
    fullName: "",
    dob: "",
    gender: "",
    className: "",
    phone: "",
    email: "",
    address: "",
    fatherName: "",
    fatherOccupation: "",
    motherName: "",
    motherOccupation: "",
    guardianNID: "",
    guardianRelation: "",
    guardianPhone: "",
    birthCertNo: "",
    bloodGroup: "",
    religion: "",
    nationality: "",
    file: null,
    permanentVillage: "",
    permanentPost: "",
    permanentUpazila: "",
    permanentDistrict: "",
    presentVillage: "",
    presentPost: "",
    presentUpazila: "",
    presentDistrict: "",
    prevOrgName: "",
    prevOrgAddress: "",
    prevOrganization: "",
    familyMembers: "",
    familyEarning: "",
  });

  const [sameAddress, setSameAddress] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSameAddress = () => {
    const newValue = !sameAddress;
    setSameAddress(newValue);

    if (newValue) {
      setFormData({
        ...formData,
        presentVillage: formData.permanentVillage,
        presentPost: formData.permanentPost,
        presentUpazila: formData.permanentUpazila,
        presentDistrict: formData.permanentDistrict,
      });
    } else {
      setFormData({
        ...formData,
        presentVillage: "",
        presentPost: "",
        presentUpazila: "",
        presentDistrict: "",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agreed) {
      alert("অনুগ্রহ করে অঙ্গীকারনামা চেকবক্সে টিক দিন।");
      return;
    }
    console.log("Form submitted:", formData);
    alert("Your application has been submitted successfully!");
  };

  return (
    <div className="apply-online-page">
      <h2 className="form-title">Apply Online (শিক্ষার্থী ভর্তি ফর্ম)</h2>
      <p className="form-subtitle">
        Please fill in the following information accurately. (অনুগ্রহ করে সঠিক তথ্য দিন)
      </p>

      <form className="apply-form" onSubmit={handleSubmit}>
        <div className="form-top-section">
        <div className="form-left">
            <div className="form-group">
            <label>Class You’re Applying For (ভর্তি হতে চাওয়া ক্লাস)</label>
            <select
                name="className"
                value={formData.className}
                onChange={handleChange}
                required
            >
                <option value="">Select Class</option>
                <option value="Class Six">Class Six</option>
                <option value="Class Seven">Class Seven</option>
                <option value="Class Eight">Class Eight</option>
                <option value="Class Nine">Class Nine</option>
                <option value="Class Ten">Class Ten</option>
            </select>
            </div>
        </div>

        <div className="form-right">
            <label>Photo Preview (ছবি)</label>
            <div className="photo-preview">
            {formData.file && formData.file.type.startsWith("image/") ? (
                <img
                src={URL.createObjectURL(formData.file)}
                alt="Preview"
                className="preview-img"
                />
            ) : (
                <span>No Photo Uploaded</span>
            )}
            </div>
        </div>
        </div>


          
        {/* Student Info */}
        <div className="form-group">
          <label>Student Name (শিক্ষার্থীর নাম)</label>
          <input
            type="text"
            name="fullName"
            placeholder="Enter your full name"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>

        {/* Parent Info */}
        <div className="form-row">
          <div className="form-group">
            <label>Father's Name (পিতার নাম)</label>
            <input
              type="text"
              name="fatherName"
              placeholder="Enter father's name"
              value={formData.fatherName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Father's Occupation (পিতার পেশা)</label>
            <input
              type="text"
              name="fatherOccupation"
              placeholder="Enter father's occupation"
              value={formData.fatherOccupation}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Mother's Name (মাতার নাম)</label>
            <input
              type="text"
              name="motherName"
              placeholder="Enter mother's name"
              value={formData.motherName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Mother's Occupation (মাতার পেশা)</label>
            <input
              type="text"
              name="motherOccupation"
              placeholder="Enter mother's occupation"
              value={formData.motherOccupation}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Date of Birth & Birth Certificate */}
        <div className="form-row">
          <div className="form-group">
            <label>Date of Birth (জন্ম তারিখ)</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Birth Certificate No (জন্ম নিবন্ধন নম্বর)</label>
            <input
              type="text"
              name="birthCertNo"
              placeholder="Enter birth certificate number"
              value={formData.birthCertNo}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Gender & Blood Group */}
        <div className="form-row">
          <div className="form-group">
            <label>Gender (লিঙ্গ)</label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Blood Group (রক্তের গ্রুপ)</label>
            <select
              name="bloodGroup"
              value={formData.bloodGroup}
              onChange={handleChange}
              required
            >
              <option value="">Select Blood Group</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
          </div>
        </div>

        {/* Religion & Nationality */}
        <div className="form-row">
          <div className="form-group">
            <label>Religion (ধর্ম)</label>
            <select
              name="religion"
              value={formData.religion}
              onChange={handleChange}
              required
            >
              <option value="">Select Religion</option>
              <option value="Islam">Islam</option>
              <option value="Hinduism">Hinduism</option>
              <option value="Christianity">Christianity</option>
              <option value="Buddhism">Buddhism</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label>Nationality (জাতীয়তা)</label>
            <input
              type="text"
              name="nationality"
              placeholder="Enter nationality"
              value={formData.nationality}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Guardian Info */}
        <div className="form-row">
          <div className="form-group">
            <label>Guardian NID (অভিভাবকের জাতীয় পরিচয়পত্র নম্বর)</label>
            <input
              type="text"
              name="guardianNID"
              placeholder="Enter guardian NID"
              value={formData.guardianNID}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Relation with Guardian (অভিভাবকের সাথে সম্পর্ক)</label>
            <input
              type="text"
              name="guardianRelation"
              placeholder="Enter relation with guardian"
              value={formData.guardianRelation}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Guardian Phone Number (অভিভাবকের ফোন নম্বর)</label>
            <input
              type="tel"
              name="guardianPhone"
              placeholder="Enter guardian phone number"
              value={formData.guardianPhone}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Address Section */}

        {/* Permanent Address */}
        <div className="address-section">
        <h4>Permanent Address (স্থায়ী ঠিকানা)</h4>
        <div className="form-row">
            <div className="form-group">
            <label>Village (গ্রাম)</label>
            <input
                type="text"
                name="permanentVillage"
                placeholder="Enter village name"
                value={formData.permanentVillage}
                onChange={handleChange}
                required
            />
            </div>
            <div className="form-group">
            <label>Post Office (ডাকঘর)</label>
            <input
                type="text"
                name="permanentPost"
                placeholder="Enter post office"
                value={formData.permanentPost}
                onChange={handleChange}
                required
            />
            </div>
        </div>
        <div className="form-row">
            <div className="form-group">
            <label>Upazila (উপজেলা)</label>
            <input
                type="text"
                name="permanentUpazila"
                placeholder="Enter upazila"
                value={formData.permanentUpazila}
                onChange={handleChange}
                required
            />
            </div>
            <div className="form-group">
            <label>District (জেলা)</label>
            <input
                type="text"
                name="permanentDistrict"
                placeholder="Enter district"
                value={formData.permanentDistrict}
                onChange={handleChange}
                required
            />
            </div>
        </div>
        </div>

        {/* Present Address */}
        <div className="address-section">
        <h4>Present Address (বর্তমান ঠিকানা)</h4>
        <label className="same-address">
            <input
            type="checkbox"
            checked={sameAddress}
            onChange={handleSameAddress}
            />{" "}
            Same as Permanent Address
        </label>
        <div className="form-row">
            <div className="form-group">
            <label>Village (গ্রাম)</label>
            <input
                type="text"
                name="presentVillage"
                placeholder="Enter village name"
                value={formData.presentVillage}
                onChange={handleChange}
                required
            />
            </div>
            <div className="form-group">
            <label>Post Office (ডাকঘর)</label>
            <input
                type="text"
                name="presentPost"
                placeholder="Enter post office"
                value={formData.presentPost}
                onChange={handleChange}
                required
            />
            </div>
        </div>
        <div className="form-row">
            <div className="form-group">
            <label>Upazila (উপজেলা)</label>
            <input
                type="text"
                name="presentUpazila"
                placeholder="Enter upazila"
                value={formData.presentUpazila}
                onChange={handleChange}
                required
            />
            </div>
            <div className="form-group">
            <label>District (জেলা)</label>
            <input
                type="text"
                name="presentDistrict"
                placeholder="Enter district"
                value={formData.presentDistrict}
                onChange={handleChange}
                required
            />
            </div>
        </div>
        </div>

        {/* Previous Organization Info */}
        <div className="form-row">
        <div className="form-group">
            <label>Previous Organization Name (পূর্ববর্তী প্রতিষ্ঠানের নাম)</label>
            <input
            type="text"
            name="prevOrgName"
            placeholder="Enter previous organization name"
            value={formData.prevOrgName || ""}
            onChange={handleChange}
            />
        </div>
        <div className="form-group">
            <label>Previous Organization Address (পূর্ববর্তী প্রতিষ্ঠানের ঠিকানা)</label>
            <input
            type="text"
            name="prevOrgAddress"
            placeholder="Enter previous organization address"
            value={formData.prevOrgAddress || ""}
            onChange={handleChange}
            />
        </div>
        </div>

        <div className="form-row">
        <div className="form-group">
            <label>Previous Organization (পূর্ববর্তী প্রতিষ্ঠান)</label>
            <input
            type="text"
            name="prevOrganization"
            placeholder="Enter previous organization"
            value={formData.prevOrganization || ""}
            onChange={handleChange}
            />
        </div>
        </div>

        {/* Family Details */}
        <div className="form-row">
        <div className="form-group">
            <label>Number of Family Members (পরিবারের সদস্য সংখ্যা)</label>
            <input
            type="number"
            name="familyMembers"
            placeholder="Enter number of family members"
            value={formData.familyMembers || ""}
            onChange={handleChange}
            />
        </div>
        <div className="form-group">
            <label>Family Earning (Yearly) (পরিবারের বার্ষিক আয়)</label>
            <input
            type="number"
            name="familyEarning"
            placeholder="Enter yearly family earning"
            value={formData.familyEarning || ""}
            onChange={handleChange}
            />
        </div>
        </div>
        
        {/* File Upload */}
        <div className="form-group">
          <label>Upload Photo / Certificate</label>
          <input
            type="file"
            name="file"
            accept=".jpg, .jpeg, .png, .pdf"
            onChange={handleChange}
          />
        </div>

        {/* Confirmation Checkbox */}
        <div className="form-group">
          <label className="confirmation-label">
            <input
              type="checkbox"
              checked={agreed}
              onChange={() => setAgreed(!agreed)}
              required
            />{" "}
            আমি স্বজ্ঞানে অঙ্গীকার করছি যে, উপরোক্ত তথ্যাদি সঠিক। আমি অঙ্গীকার করছি যে, স্কুলের বর্তমান নিয়ম-কানুন এবং ভবিষ্যতে যে নিয়ম-নীতি বাস্তবায়িত হবে সেগুলো মেনে চলবো। আমি আরোও অঙ্গীকার করছি যে, বিদ্যালয়ের নিয়ম-কানুন বা শর্ত লঙ্ঘনের কারণে বিদ্যালয় প্রশাসন শিক্ষার্থীকে কোন প্রকার বিনা ক্ষতিপূরণে বিদ্যালয় থেকে বহিষ্কার করার অধিকার রাখে। অতএব, আমি সমস্ত নিয়ম-কানুন মেনে চলতে এবং বিদ্যালয় প্রশাসন ও শিক্ষকদের সাথে সহযোগিতা করতে সম্মত।
          </label>
        </div>

        <button type="submit" className="submit-btn">
          Submit Application
        </button>
      </form>
    </div>
  );
}
